<template>
  <div v-if="guarantType" v-loading="loading" class="guarantForm">
    <div class="guarantForm__message">
      <p v-if="form.confirmed_at" class="guarantForm__message--success">
        {{ $t('records.guarant.form.emailConfirm') }}{{ form.email
        }}{{ $t('records.guarant.form.emailConfirmed')
        }}{{ $moment(form.confirmed_at).format('DD/MM/YYYY, hh:mm') }}.
      </p>
      <p
        v-if="form.confirmation_sent_at && !form.confirmed_at"
        class="guarantForm__message--warning"
      >
        {{ $t('records.guarant.form.emailConfirm') }}{{ form.email
        }}{{ $t('records.guarant.form.emailConfirmSent')
        }}{{ $moment(form.confirmation_sent_at).format('DD/MM/YYYY, hh:mm') }}.
      </p>
    </div>
    <el-form
      ref="guarantForm"
      class="guarantForm"
      :model="form"
      :rules="rules"
      @submit.native.prevent="onSubmit"
    >
      <div class="guarantForm__form">
        <h4 v-if="editionMode">
          {{ $t('records.guarant.form.title.edition') }}
        </h4>
        <h4 v-else>{{ $t('records.guarant.form.title.creation') }}</h4>
        <p v-if="guarantType === '0'">
          {{ $t('records.guarant.form.subtitle.person') }}
        </p>
        <p v-else>{{ $t('records.guarant.form.subtitle.guarantee') }}</p>
        <!-- SITUATION -->
        <template v-if="guarantType === '0'">
          <el-row :gutter="56">
            <el-col :lg="10">
              <el-form-item
                class="guarantForm__situation"
                :label="$t('records.guarant.form.situationLabel')"
              >
                <el-select
                  v-model="form.situation"
                  class="situationSelect"
                  :placeholder="$t('records.guarant.form.situationPlaceholder')"
                  @change="situationChange"
                >
                  <el-option
                    v-for="situation in situations"
                    :key="situation"
                    :label="$t(`records.guarant.form.situations.${situation}`)"
                    :value="situation"
                  >
                    {{ $t(`records.guarant.form.situations.${situation}`) }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <!-- institutional_guarantor_id && institutional_guarantor_number -->
        <template v-if="guarantType === '1'">
          <el-row :gutter="56">
            <!-- field en v-show -->
            <el-col v-show="false" :sm="12" :lg="8">
              <el-form-item
                prop="institutional_guarantor_number"
                :label="
                  $t('records.guarant.form.institutionalGuarantorNumberLabel')
                "
              >
                <el-input
                  v-model="form.institutional_guarantor_number"
                  name="institutional_guarantor_number"
                  :placeholder="
                    $t(
                      'records.guarant.form.institutionalGuarantorNumberPlaceholder'
                    )
                  "
                />
              </el-form-item>
            </el-col>
            <el-col :sm="12" :xl="8">
              <el-form-item
                prop="institutional_guarantor_id"
                :label="$t('records.guarant.form.institutionalGuarantorLabel')"
              >
                <institutional-guarantor-select
                  v-model="form.institutional_guarantor_id"
                  :placeholder="
                    $t('records.guarant.form.institutionalGuarantorPlaceholder')
                  "
                ></institutional-guarantor-select>
              </el-form-item>
            </el-col>
            <el-col :sm="12" :xl="8">
              <el-form-item
                prop="institutional_guarantor_number"
                :label="
                  $t('records.guarant.form.institutionalGuarantorNumberLabel')
                "
              >
                <el-input
                  v-model="form.institutional_guarantor_number"
                  name="institutional_guarantor_number"
                  :placeholder="
                    $t(
                      'records.guarant.form.institutionalGuarantorNumberPlaceholder'
                    )
                  "
                />
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <template v-if="guarantType === '0' && form.situation">
          <!-- GENDER -->
          <el-form-item
            class="guarantForm__gender"
            :label="$t('records.guarant.form.civilityLabel')"
            prop="gender"
          >
            <el-radio-group v-model="form.gender">
              <el-radio :label="'male'">{{
                $t('records.guarant.form.civilityMale')
              }}</el-radio>
              <el-radio :label="'female'">{{
                $t('records.guarant.form.civilityFemale')
              }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- FIRSTNAME & LASTNAME & MAIDENNAME -->
          <el-row :gutter="56">
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.firstNameLabel')"
                prop="first_name"
              >
                <el-input
                  v-model="form.first_name"
                  name="first_name"
                  :placeholder="$t('records.guarant.form.firstNamePlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.lastNameLabel')"
                prop="last_name"
              >
                <el-input
                  v-model="form.last_name"
                  name="last_name"
				          onkeyup="this.value=this.value.toUpperCase()"
				          class="uppercase"
                  :placeholder="$t('records.guarant.form.lastNamePlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="`${$t('records.guarant.form.originalLastNameLabel')}${form.gender === 'female' ? ' * :' : ' :'}`"
                prop="original_last_name"
              >
                <el-input
                  v-model="form.original_last_name"
                  name="original_last_name"
                  :placeholder="
                    $t('records.guarant.form.originalLastNamePlaceholder')
                  "
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- EMAIL & PHONE_NUMBER -->
          <el-row :gutter="56">
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.emailLabel')"
                prop="email"
              >
                <el-input
                  v-model="form.email"
                  name="email"
                  :placeholder="$t('records.guarant.form.emailPlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.phoneNumberLabel')"
                prop="phone_number"
              >
                <phone-input
                  :data="{
                    localValue: form.phone_number,
                    countryCode: form.phone_country_code
                  }"
                  @update="updateGuarantPhone"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ADDRESS -->
          <el-row :gutter="56">
            <el-col :lg="10">
              <el-form-item
                :label="$t('records.guarant.form.addressLabel')"
                prop="address"
              >
                <el-input
                  v-model="form.address"
                  type="textarea"
                  name="address"
                  :placeholder="$t('records.guarant.form.addressPlaceholder')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ZIP_CODE & CITY & COUNTRY -->
          <el-row :gutter="56">
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.zipCodeLabel')"
                prop="zip_code"
              >
                <el-input
                  v-model="form.zip_code"
                  name="zip_code"
                  :placeholder="$t('records.guarant.form.zipCodePlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.cityLabel')"
                prop="city"
              >
                <el-input
                  v-model="form.city"
                  name="city"
                  :placeholder="$t('records.guarant.form.cityPlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.countryLabel')"
                prop="country_id"
              >
                <country-select
                  v-model="form.country_id"
                  :placeholder="$t('records.guarant.form.countryPlaceholder')"
                ></country-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- NATIONALITY & DATE_OF_BIRTH -->
          <el-row :gutter="56">
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.nationalityLabel')"
                prop="nationality_id"
              >
                <nationality-select
                  v-model="form.nationality_id"
                  :placeholder="
                    $t('records.guarant.form.nationalityPlaceholder')
                  "
                ></nationality-select>
              </el-form-item>
            </el-col>
            <el-col :lg="10">
              <el-form-item
                :label="$t('records.guarant.form.dateOfBirthLabel')"
                prop="date_of_birth"
              >
                <date-picker-input
                  v-model="form.date_of_birth"
                  :value="form.date_of_birth"
                  :disabled-date="dateValidation"
                  :placeholder="
                    $t('records.guarant.form.dateOfBirthPlaceholder')
                  "
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- BIRTH_CITY & BIRTH_COUNTRY_ID & FAMILY_SITUATION_ID -->
          <el-row :gutter="56">
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.birthCityLabel')"
                prop="birth_city"
              >
                <el-input
                  v-model="form.birth_city"
                  name="birth_city"
                  :placeholder="$t('records.guarant.form.birthCityPlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.birthCountryLabel')"
                prop="birth_country_id"
              >
                <country-select
                  v-model="form.birth_country_id"
                  :placeholder="
                    $t('records.guarant.form.birthCountryPlaceholder')
                  "
                ></country-select>
              </el-form-item>
            </el-col>
            <el-col :sm="12" :lg="8">
              <el-form-item
                :label="$t('records.guarant.form.familySituationLabel')"
                prop="family_situation_id"
              >
                <family-situation-select
                  v-model="form.family_situation_id"
                  :placeholder="
                    $t('records.guarant.form.familySituationPlaceholder')
                  "
                ></family-situation-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div>
            <!-- start of INFORMATIONS -->
            <h4>{{ $t('records.guarant.form.informationsTitle') }}</h4>
            <p>{{ $t(`records.guarant.form.situations.${form.situation}`) }}</p>

            <!-- company_name -->
            <el-row
              v-show="['employee', 'other'].includes(form.situation)"
              :gutter="56"
            >
              <el-col :lg="10">
                <el-form-item
                  :label="`${$t('records.guarant.form.companyNameLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                  prop="company_name"
                >
                  <el-input
                    v-model="form.company_name"
                    name="company_name"
                    :placeholder="
                      $t('records.guarant.form.companyNamePlaceholder')
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- company_address-->
            <el-row
              v-show="
                ['employee', 'other', 'professional'].includes(form.situation)
              "
              :gutter="56"
            >
              <el-col :lg="10">
                <el-form-item
                  :label="`${$t('records.guarant.form.companyAddressLabel')} :`"
                  prop="company_address"
                >
                  <el-input
                    v-model="form.company_address"
                    type="textarea"
                    name="company_address"
                    :placeholder="
                      $t('records.guarant.form.companyAddressPlaceholder')
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- company_zip_code & company_city & company_country_id -->
            <el-row
              v-show="
                ['employee', 'other', 'professional'].includes(form.situation)
              "
              :gutter="56"
            >
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="`${$t('records.guarant.form.companyZipCodeLabel')} :`"
                  prop="company_zip_code"
                >
                  <el-input
                    v-model="form.company_zip_code"
                    name="company_zip_code"
                    :placeholder="
                      $t('records.guarant.form.companyZipCodePlaceholder')
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="`${$t('records.guarant.form.companyCityLabel')} :`"
                  prop="company_city"
                >
                  <el-input
                    v-model="form.company_city"
                    name="company_city"
                    :placeholder="
                      $t('records.guarant.form.companyCityPlaceholder')
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="`${$t('records.guarant.form.companyCountryLabel')} :`"
                  prop="company_country_id"
                >
                  <country-select
                    v-model="form.company_country_id"
                    :value="form.company_country_id"
                    :placeholder="
                      $t('records.guarant.form.companyCountryPlaceholder')
                    "
                  ></country-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- company_phone_number -->
            <el-row
              v-show="
                ['employee', 'other', 'professional'].includes(form.situation)
              "
              :gutter="56"
            >
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="`${$t('records.guarant.form.companyPhoneNumberLabel')} :`"
                  prop="company_phone_number"
                >
                  <phone-input
                    :data="{
                      localValue: form.company_phone_number,
                      countryCode: form.company_phone_country_code
                    }"
                    @update="updateCompanyPhone"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- occupation & activity_sector_id -->
            <el-row :gutter="56">
              <el-col
                v-show="['employee', 'other'].includes(form.situation)"
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="`${$t('records.guarant.form.occupationLabel')} :`"
                  prop="occupation"
                >
                  <el-input
                    v-model="form.occupation"
                    name="occupation"
                    :placeholder="
                      $t('records.guarant.form.occupationPlaceholder')
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-show="
                  ['employee', 'other', 'professional'].includes(form.situation)
                "
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="`${$t('records.guarant.form.activitySectorLabel')} :`"
                  prop="activity_sector_id"
                >
                  <activity-sector-select
                    v-model="form.activity_sector_id"
                    :placeholder="
                      $t('records.guarant.form.activitySectorPlaceholder')
                    "
                  ></activity-sector-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- hiring_date & employment_contract_id -->
            <el-row
              v-show="['employee', 'other'].includes(form.situation)"
              :gutter="56"
            >
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="`${$t('records.guarant.form.hiringDateLabel')} :`"
                  prop="hiring_date"
                >
                  <date-picker-input
                    v-model="form.hiring_date"
                    :value="form.hiring_date"
                    :placeholder="
                      $t('records.guarant.form.hiringDatePlaceholder')
                    "
                  />
                  <span class="guarantForm__hint">{{
                    $t('records.guarant.form.hiringDateHint')
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="`${$t('records.guarant.form.employmentContractLabel')}${['employee', 'other'].includes(form.situation) ? ' * :' : ' :'}`"
                  prop="employment_contract_id"
                >
                  <employment-contract-select
                    v-model="form.employment_contract_id"
                    :placeholder="
                      $t('records.guarant.form.employmentContractPlaceholder')
                    "
                  ></employment-contract-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- net_monthly_income -->
            <el-row :gutter="56">
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="
                    `${$t('records.guarant.form.netMonthlyIncomeLabel')}${
                      form.situation !== 'professional' ? ' * :' : ' :'
                    }`
                  "
                  prop="net_monthly_income"
                >
                  <el-input
                    v-model.number="form.net_monthly_income"
                    name="net_monthly_income"
                    type="number"
                    :placeholder="
                      $t('records.guarant.form.netMonthlyIncomePlaceholder')
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- OWNER -->
            <el-form-item
              :label="$t('records.guarant.form.ownerLabel')"
              prop="owner"
            >
              <el-radio-group
                v-model="form.owner"
                class="guarantForm__radioGroup"
              >
                <el-radio :label="true">
                  {{ $t('records.guarant.form.radio_yes') }}
                </el-radio>
                <el-radio :label="false">
                  {{ $t('records.guarant.form.radio_no') }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- monthly_rent_for_tenants & other_monthly_expenses -->
            <el-row v-show="!form.owner" :gutter="56">
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="$t('records.guarant.form.monthlyRentForTenantsLabel')"
                  prop="monthly_rent_for_tenants"
                >
                  <el-input
                    v-model.number="form.monthly_rent_for_tenants"
                    name="monthly_rent_for_tenants"
                    type="number"
                    :placeholder="
                      $t(
                        'records.guarant.form.monthlyRentForTenantsPlaceholder'
                      )
                    "
                  />
                  <span class="guarantForm__hint">{{
                    $t('records.guarant.form.monthlyRentForTenantsHint')
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="$t('records.guarant.form.otherMonthlyExpensesLabel')"
                  prop="other_monthly_expenses"
                >
                  <el-input
                    v-model.number="form.other_monthly_expenses"
                    name="other_monthly_expenses"
                    type="number"
                    :placeholder="
                      $t('records.guarant.form.otherMonthlyExpensesPlaceholder')
                    "
                  />
                  <span class="guarantForm__hint">{{
                    $t('records.guarant.form.otherMonthlyExpensesHint')
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- activity_started_at & retired_since -->
            <el-row :gutter="56">
              <el-col
                v-show="form.situation === 'professional'"
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="$t('records.guarant.form.activityStartedAtLabel')"
                  prop="activity_started_at"
                >
                  <date-picker-input
                    v-model="form.activity_started_at"
                    :value="form.activity_started_at"
                    :placeholder="
                      $t('records.guarant.form.activityStartedAtPlaceholder')
                    "
                  />
                  <span class="guarantForm__hint">{{
                    $t('records.guarant.form.activityStartedAtHint')
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col v-show="form.situation === 'pensioner'" :sm="12" :lg="8">
                <el-form-item
                  :label="$t('records.guarant.form.retiredSinceLabel')"
                  prop="retired_since"
                >
                  <date-picker-input
                    v-model="form.retired_since"
                    :value="form.retired_since"
                    :placeholder="
                      $t('records.guarant.form.retiredSincePlaceholder')
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- situation_comment -->
            <el-form-item
              v-show="form.situation === 'other'"
              :label="$t('records.guarant.form.situationCommentLabel')"
              prop="situation_comment"
            >
              <el-input
                v-model="form.situation_comment"
                type="textarea"
                name="situation_comment"
                :placeholder="
                  $t('records.guarant.form.situationCommentPlaceholder')
                "
              />
              <span class="guarantForm__hint">{{
                $t('records.guarant.form.situationCommentHint')
              }}</span>
            </el-form-item>

            <!-- company_type_id -->
            <el-row v-show="form.situation === 'professional'" :gutter="56">
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="$t('records.guarant.form.companyTypeLabel')"
                  prop="company_type_id"
                >
                  <company-type-select
                    v-model="form.company_type_id"
                    :placeholder="
                      $t('records.guarant.form.companyTypePlaceholder')
                    "
                  ></company-type-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- tax_revenue_year_minus_one -->
            <el-row :gutter="56">
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="
                    $t('records.guarant.form.taxRevenueYearMinusOneLabel')
                  "
                  prop="tax_revenue_year_minus_one"
                >
                  <el-input
                    v-model.number="form.tax_revenue_year_minus_one"
                    name="tax_revenue_year_minus_one"
                    type="number"
                    :placeholder="
                      $t(
                        'records.guarant.form.taxRevenueYearMinusOnePlaceholder'
                      )
                    "
                  />
                  <span class="guarantForm__hint">{{
                    $t('records.guarant.form.taxRevenueYearMinusOneHint')
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="$t('records.guarant.form.tenantRelationshipLabel')"
                  prop="tenant_relationship_id"
                >
                  <tenant-relationship-select
                    v-model="form.tenant_relationship_id"
                    :placeholder="
                      $t('records.guarant.form.tenantRelationshipPlaceholder')
                    "
                  ></tenant-relationship-select>
                </el-form-item>
              </el-col>
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="$t('records.guarant.form.maritalStatusLabel')"
                  prop="marital_status_id"
                >
                  <marital-status-select
                    v-model="form.marital_status_id"
                    :placeholder="
                      $t('records.guarant.form.maritalStatusPlaceholder')
                    "
                  ></marital-status-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- number_of_dependents -->
            <el-row :gutter="56">
              <el-col :sm="12" :lg="8">
                <el-form-item
                  :label="$t('records.guarant.form.numberOfDependentsLabel')"
                  prop="number_of_dependents"
                >
                  <el-input
                    v-model.number="form.number_of_dependents"
                    name="number_of_dependents"
                    type="number"
                    :placeholder="
                      $t('records.guarant.form.numberOfDependentsPlaceholder')
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- end of INFORMATIONS -->
          </div>
        </template>
      </div>
      <div class="guarantForm__action">
        <el-row class="guarantForm__save-container">
          <el-col :sm="20">
            <p>
              {{ $t('records.guarant.form.save') }}
            </p>
          </el-col>
          <el-col :sm="4">
            <el-button
              class="guarantForm__save"
              type="secondary"
              :loading="inProgress"
              :disabled="guarantType === '0' && !form.situation"
              native-type="submit"
              >{{ $t('records.guarant.form.continueButton') }}</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import ActivitySectorSelect from '@/components/ui/ActivitySectorSelect'
import CompanyTypeSelect from '@/components/ui/CompanyTypeSelect'
import CountrySelect from '@/components/ui/CountrySelect'
import DatePickerInput from '@/components/ui/DatePickerInput'
import EmploymentContractSelect from '@/components/ui/EmploymentContractSelect'
import FamilySituationSelect from '@/components/ui/FamilySituationSelect'
import InstitutionalGuarantorSelect from '@/components/ui/InstitutionalGuarantorSelect'
import MaritalStatusSelect from '@/components/ui/MaritalStatusSelect'
import NationalitySelect from '@/components/ui/NationalitySelect'
import PhoneInput from '@/components/ui/PhoneInput'
import TenantRelationshipSelect from '@/components/ui/TenantRelationshipSelect'
import { mapState } from 'vuex'

export default {
  name: 'GuarantForm',
  components: {
    ActivitySectorSelect,
    CompanyTypeSelect,
    CountrySelect,
    DatePickerInput,
    EmploymentContractSelect,
    FamilySituationSelect,
    InstitutionalGuarantorSelect,
    MaritalStatusSelect,
    NationalitySelect,
    PhoneInput,
    TenantRelationshipSelect
  },
  data: () => ({
    loading: false,
    inProgress: false,
    situations: ['employee', 'other', 'professional', 'pensioner'],
    defaultForm: {
      situation: null,
      institutional_guarantor_id: null,
      institutional_guarantor_number: null,
      gender: null,
      first_name: null,
      last_name: null,
      original_last_name: null,
      email: null,
      phone_number: null,
      phone_country_code: null,
      address: null,
      zip_code: null,
      city: null,
      country_id: null,
      date_of_birth: null,
      birth_city: null,
      birth_country_id: null,
      nationality_id: null,
      family_situation_id: null,
      company_name: null,
      company_address: null,
      company_zip_code: null,
      company_city: null,
      company_country_id: null,
      company_phone_number: null,
      company_phone_country_code: null,
      occupation: null,
      activity_sector_id: null,
      hiring_date: null,
      employment_contract_id: null,
      net_monthly_income: null,
      owner: true,
      monthly_rent_for_tenants: null,
      other_monthly_expenses: null,
      activity_started_at: null,
      retired_since: null,
      situation_comment: null,
      company_type_id: null,
      tax_revenue_year_minus_one: null,
      tenant_relationship_id: null,
      marital_status_id: null,
      number_of_dependents: null
    },
    form: {}
  }),
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord,
      currentRecordGuarantorId: state =>
        state.recordsPeople.currentRecordGuarantors &&
        state.recordsPeople.currentRecordGuarantors.length > 0
          ? state.recordsPeople.currentRecordGuarantors[
              state.recordsPeople.currentRecordGuarantors.length - 1
            ].id
          : null,
      currentRecordTenants: state => state.recordsPeople.currentRecordTenants,
      currentRecordGuarantors: state =>
        state.recordsPeople.currentRecordGuarantors
    }),
    editionMode() {
      return !!this.$route.params.guarantor_id
    },
    rules() {
      return this.guarantType === '0'
        ? {
            situation: {
              required: true,
              type: 'string',
              message: this.$t('records.guarant.form.situationInvalid')
            },
            gender: {
              required: true,
              type: 'string',
              message: this.$t('records.guarant.form.civilityInvalid')
            },
            first_name: {
              required: true,
              type: 'string',
              message: this.$t('records.guarant.form.firstNameInvalid')
            },
            last_name: {
              required: true,
              type: 'string',
              message: this.$t('records.guarant.form.lastNameInvalid')
            },
            original_last_name: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.originalLastNameInvalid')
            },
            email: {
              type: 'email',
              required: true,
              trigger: 'blur',
              message: this.$t('records.guarant.form.emailInvalid')
            },
            phone_number: {
              required: true,
              type: 'string',
              message: this.$t('records.guarant.form.phoneNumberInvalid')
            },
            address: {
              required: this.form.situation !== 'international_student',
              type: 'string',
              message: this.$t('records.guarant.form.addressInvalid')
            },
            zip_code: {
              required: this.form.situation !== 'international_student',
              type: 'string',
              message: this.$t('records.guarant.form.zipCodeInvalid')
            },
            city: {
              required: this.form.situation !== 'international_student',
              type: 'string',
              message: this.$t('records.guarant.form.cityInvalid')
            },
            country_id: {
              required: true,
              type: 'number',
              message: this.$t('records.guarant.form.countryInvalid')
            },
            international_address: {
              required: this.form.situation === 'international_student',
              type: 'string',
              message: this.$t(
                'records.guarant.form.internationalAddressInvalid'
              )
            },
            nationality_id: {
              required: true,
              type: 'number',
              message: this.$t('records.guarant.form.nationalityInvalid')
            },
            date_of_birth: {
              required: true,
              type: 'string',
              message: this.$t('records.guarant.form.dateOfBirthInvalid')
            },
            birth_city: {
              required: true,
              type: 'string',
              message: this.$t('records.guarant.form.birthCityInvalid')
            },
            birth_country_id: {
              required: true,
              type: 'number',
              message: this.$t('records.guarant.form.birthCountryInvalid')
            },
            family_situation_id: {
              required: false,
              type: 'number',
              message: this.$t('records.guarant.form.familySituationInvalid')
            },
            company_name: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.companyNameInvalid')
            },
            company_address: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.companyAddressInvalid')
            },
            company_zip_code: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.companyZipCodeInvalid')
            },
            company_city: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.companyCityInvalid')
            },
            company_country_id: {
              required: false,
              type: 'number',
              message: this.$t('records.guarant.form.companyCountryInvalid')
            },
            company_phone_number: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.companyPhoneNumberInvalid')
            },
            occupation: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.occupationInvalid')
            },
            activity_sector_id: {
              required: false,
              type: 'number',
              message: this.$t('records.guarant.form.activitySectorInvalid')
            },
            hiring_date: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.hiringDateInvalid')
            },
            employment_contract_id: {
              required: ['employee', 'other'].includes(this.form.situation),
              type: 'number',
              message: this.$t('records.guarant.form.employmentContractInvalid')
            },
            net_monthly_income: {
              required: this.form.situation !== 'professional',
              type: 'number',
              message: this.$t('records.guarant.form.netMonthlyIncomeInvalid')
            },
            owner: {
              required: false,
              type: 'boolean',
              message: this.$t('records.guarant.form.ownerInvalid')
            },
            monthly_rent_for_tenants: {
              required: false,
              type: 'number',
              message: this.$t(
                'records.guarant.form.monthlyRentForTenantsInvalid'
              )
            },
            other_monthly_expenses: {
              required: false,
              type: 'number',
              message: this.$t(
                'records.guarant.form.otherMonthlyExpensesInvalid'
              )
            },
            activity_started_at: {
              required: false,
              type: 'string',
              message: this.$t('records.guarant.form.activityStartedAtInvalid')
            },
            retired_since: {
              required: this.form.situation === 'pensioner',
              type: 'string',
              message: this.$t('records.guarant.form.retiredSinceInvalid')
            },
            situation_comment: {
              required: this.form.situation === 'other',
              type: 'string',
              message: this.$t('records.guarant.form.situationCommentInvalid')
            },
            company_type_id: {
              required: this.form.situation === 'professional',
              type: 'number',
              message: this.$t('records.guarant.form.companyTypeInvalid')
            },
            tax_revenue_year_minus_one: {
              required: true,
              type: 'number',
              message: this.$t(
                'records.guarant.form.taxRevenueYearMinusOneInvalid'
              )
            },
            tenant_relationship_id: {
              required: true,
              type: 'number',
              message: this.$t('records.guarant.form.tenantRelationshipInvalid')
            },
            marital_status_id: {
              required: false,
              type: 'number',
              message: this.$t('records.guarant.form.maritalStatusInvalid')
            },
            number_of_dependents: {
              required: false,
              type: 'number',
              message: this.$t('records.guarant.form.numberOfDependentsInvalid')
            }
          }
        : {
            institutional_guarantor_id: {
              required: true,
              type: 'number',
              message: this.$t(
                'records.guarant.form.institutionalGuarantorInvalid'
              )
            },
            institutional_guarantor_number: {
              required: false,
              type: 'string',
              message: this.$t(
                'records.guarant.form.institutionalGuarantorNumberInvalid'
              )
            }
          }
    },
    guarantType() {
      return this.$store.getters['recordsPeople/guarantType']
    },
    guarantId() {
      if (this.$route.params.guarantor_id) {
        return this.$route.params.guarantor_id
      } else {
        return this.$store.getters['recordsPeople/guarantId']
      }
    }
  },
  watch: {
    guarantId: {
      immediate: true,
      async handler(newVal) {
        this.loading = true
        if (newVal === 'garantie-locative') {
          this.$store.dispatch('recordsPeople/setGuarantType', '1')
          if (this.currentRecord && this.currentRecord.institutional_guarantor && this.currentRecord.institutional_guarantor_number) {
            this.form = {
              institutional_guarantor_id: this.currentRecord
                .institutional_guarantor.id,
              institutional_guarantor_number: this.currentRecord
                .institutional_guarantor_number
            }
          }
        } else if (newVal) {
          this.$store.dispatch('recordsPeople/setGuarantType', '0')
          this.form = this.$helpers.conversionHelper(
            await this.$api.recordsPeople.getGuarantor({ id: newVal })
          )
        } else {
          this.$store.dispatch('recordsPeople/setGuarantType', '0')
          this.form = Object.assign({}, this.defaultForm)
        }
        this.loading = false
      }
    }
  },
  mounted() {
    if (this.guarantId !== 'garantie-locative') {
      Object.assign(this.form, this.defaultForm)
    }
  },
  methods: {
situationChange() {
      this.$nextTick(() => {
        // reset form validation, prevent change tab
        if (this.$refs['guarantForm'] !== undefined) {
          this.$refs['guarantForm'].resetFields()
        }
      })
    },
    async onSubmit() {
      try {
        this.inProgress = true
        const validation = await this.$refs['guarantForm'].validate()
        if (validation) {
          let message = ''
          if (
            this.editionMode &&
            this.$route.params.guarantor_id !== 'garantie-locative'
          ) {
            await this.$store.dispatch('recordsPeople/updateGuarantor', {
              guarantor: this.form
            })
            message = this.$t('records.guarant.form.message.updated')
          } else {
            if (this.guarantType === '1') {
              // institutional_guarantor
              await this.$store.dispatch('records/updateRecord', {
                record: this.form,
                id: this.$route.params.id
              })
              message = this.$t('records.guarant.form.message.updatedRecord')
            } else if (this.guarantId) {
              if (this.guarantId === 'garantie-locative') {
                // institutional_guarantor
                await this.$store.dispatch('records/updateRecord', {
                  record: this.form,
                  id: this.$route.params.id
                })
                message = this.$t('records.guarant.form.message.updatedRecord')
              } else {
                // select existant guarantor
                await this.$store.dispatch('records/updateRecord', {
                  record: {
                    guarantor_ids: [
                      ...this.currentRecord.guarantor_ids,
                      this.guarantId
                    ]
                  },
                  id: this.$route.params.id
                })
              }
            } else {
              await this.$store.dispatch('recordsPeople/createGuarantor', {
                guarantor: this.form,
                record_id: this.$route.params.id
              })
              message = this.$t('records.guarant.form.message.created')
            }
          }
          this.$notify({
            type: 'success',
            title: this.$t('base.success.notificationTitle'),
            message
          })

          if (
            this.currentRecordTenants.length > 0 &&
            this.currentRecordGuarantors.length > 0
          ) {
            this.$router.push({
              path:
                '/dossiers/' +
                this.currentRecord.id +
                '/pieces-justificatives/' +
                this.currentRecordTenants[0].id
            })
          }
        }
        this.inProgress = false
      } catch (error) {
        this.inProgress = false
      }
    },
    dateValidation(date) {
      return this.$moment().diff(date, 'years') < 16
    },
    updateGuarantPhone(event) {
      this.form.phone_number = event.phoneNumber
      this.form.phone_country_code = event.countryCode
    },
    updateCompanyPhone(event) {
      this.form.company_phone_number = event.phoneNumber
      this.form.company_phone_country_code = event.countryCode
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.guarantForm';

#{$c} {
  margin-bottom: 24px;

  &__message {
    font-size: 21px;
    font-weight: 600;
    word-break: break-word;

    &--success {
      color: #207468;
    }
    &--warning {
      color: #b7202e;
    }
  }
  &__form,
  &__action {
    background-color: white;
  }
  &__form {
    margin-bottom: 24px;
  }
  &__form p {
    margin-bottom: 30px;
    margin-top: 0;
  }

  &__hint {
    color: $--color-info;
  }

  &__save-container {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      color: $--color-info;
    }

    .el-col:nth-child(2) {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
  }

  &__separator {
    border: 1px solid $--border-color-light;
  }

  .el-select,
  .el-date-editor {
    width: 100%;
  }
}
</style>
